import { throttleDomAfterAsync } from '../helpers/throttle.js';

const readMoreReadLess = () => {
	// Check for proper page.
	const page = document.querySelector('[data-id="justice-under-siege"]');
	if (!page) {
		return;
	}

	const height = 200;

	const readMore = () => {
		const boxes = document.querySelectorAll('.list__single-row__excerpt-collapse');
		Array.from(boxes).forEach((box) => {
			const existingBtn = box.parentElement.querySelector('.read-more-btn');
			if (box.scrollHeight > height && !existingBtn) {
				box.style.maxHeight = `${height}px`;
				const readMoreBtn = document.createElement('button');
				readMoreBtn.className = 'read-more-btn';
				readMoreBtn.textContent = 'Read more';
				box.parentElement.appendChild(readMoreBtn);
				box.classList.add('collapsed');
			} else if (box.scrollHeight <= height && existingBtn) {
				// If height is less than 200px, remove the read more button if it exists
				if (existingBtn) {
					existingBtn.remove();
					box.style.maxHeight = '1000px'; // Remove max-height restriction
					box.classList.remove('collapsed');
				}
			}
		});
	}

	const delegateReadMore = () => {
		// Add click event listener to read more buttons delegated to the document
		document.addEventListener('click', (event) => {
			if (event.target.classList.contains('read-more-btn')) {
				const box = event.target.parentElement.querySelector('.list__single-row__excerpt-collapse');
				if (!box) return;
				// Toggle max-height
				if (box.classList.contains('collapsed')) {
					box.style.maxHeight = '1000px';
					event.target.textContent = 'Read less';
					box.classList.remove('collapsed');
				} else {
					box.style.maxHeight = `${height}px`;
					event.target.textContent = 'Read more';
					box.classList.add('collapsed');
				}
			}
		});
	}

	// Initialize read more functionality
	readMore();
	// Initialize delete read more functionality
	delegateReadMore();

	// Watch mutation observer for changes in the DOM
	const watchSFPAJAX = () => {
		const targetNode = document.querySelector('.search-filter-results');
		if (!targetNode) return;

		const observerOptions = {
			childList: true,
			subtree: true,
		};

		const observer = new MutationObserver((mutationsList) => {
			mutationsList.forEach((mutation) => {
				if (mutation.type === 'childList' && mutation.target.classList.contains('search-filter-results')) {
					readMore(); // Reapply the read more functionality after Ajax call
				}
			});
		});

		observer.observe(targetNode, observerOptions);
	}

	// Start observing for changes in the search filter results
	watchSFPAJAX();

	// Resize event.
	addEventListener("resize", throttleDomAfterAsync(readMore, 50));
}

if (document.readyState === "complete") {
	readMoreReadLess();
} else {
	document.addEventListener("DOMContentLoaded", readMoreReadLess, 1);
}